import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import { useTranslation } from '../contexts/LanguageContext';
import '../App.css';

const CONTACT_EMAIL = 'statarena@proton.me';

const LegalShell = ({ title, description, children }) => {
  const { t } = useTranslation();

  useSeo({
    title: `${title} | StatArena`,
    description,
    canonical: `https://statarena.app${window.location.pathname}`,
    robots: 'index, follow',
    ogUrl: `https://statarena.app${window.location.pathname}`,
  });

  return (
    <main className="legal-page">
      <div className="legal-header">
        <Link to="/" className="legal-back">StatArena</Link>
        <span className="section-badge">{t('legal.badge')}</span>
      </div>
      <section className="legal-hero">
        <h1>{title}</h1>
        <p>{description}</p>
      </section>
      <div className="legal-content">{children}</div>
    </main>
  );
};

const LegalSections = ({ sections, showContact = false }) => (
  <>
    {sections.map(([title, body], index) => (
      <section key={title}>
        <h2>{title}</h2>
        <p>
          {body}
          {showContact && index === sections.length - 1 && (
            <>
              {' '}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </>
          )}
        </p>
      </section>
    ))}
  </>
);

export const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <LegalShell
      title={t('legal.privacyTitle')}
      description={t('legal.privacyDescription')}
    >
      <LegalSections sections={t('legal.privacySections')} showContact />
      <p className="legal-updated">{t('legal.updated')}</p>
    </LegalShell>
  );
};

export const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <LegalShell
      title={t('legal.termsTitle')}
      description={t('legal.termsDescription')}
    >
      <LegalSections sections={t('legal.termsSections')} showContact />
      <p className="legal-updated">{t('legal.updated')}</p>
    </LegalShell>
  );
};

export const AccountDeletion = () => {
  const { t } = useTranslation();

  return (
    <LegalShell
      title={t('legal.deletionTitle')}
      description={t('legal.deletionDescription')}
    >
      <LegalSections sections={t('legal.deletionSections')} showContact />
    </LegalShell>
  );
};

export default PrivacyPolicy;
